import React, { useEffect, useState } from "react";
import RadioButton from "../../Reusable/RadioButton";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../../Reusable/TextInput";
import MultipleSelectField from "../../Reusable/MultipleSelectField";
import APIS from "../../../constant/EndPoint";
import NumberField from "../../Reusable/NumberField";
const ReturnChargeFrom = (props: any) => {
  const {
    name,
    register,
    errors,
    watch,
    setValue,
    getValues,
    label,
    data,
    clearErrors,
  } = props;
  const [selectedRtvType, setSelectedRtvType] = useState("amount");
  const [selectedVendor, setSelectedVendor] = useState("include");
  const handleRtvTypeChange = (event) => {
    const rtvType = event.target.value;
    setSelectedRtvType(rtvType);
    if (rtvType === "amount") {
      setValue(`${name}.percentage`, "");
    } else {
      setValue(`${name}.amount`, "");
    }
  };
  // console.log(data)
  const handleVendorChange = (event) => {
    const vendorValue = event.target.value;
    setSelectedVendor(vendorValue);
  };
  const amount = watch(`${name}.amount`);
  const percentage = watch(`${name}.percentage`);

  useEffect(() => {
    if (amount) {
      setSelectedRtvType("amount");
    } else if(percentage) {
      setSelectedRtvType("percentage");
    }
  }, [amount,percentage]);
  useEffect(() => {
    if (data?.is_include) {
      setSelectedVendor("include");
    } else {
      setSelectedVendor("exclude");
    }
  }, [data]);
 
  return (
    <div className={tw`flex flex-col gap-y-2 `}>
      <span className={tw`text-center font-semibold`}>{label}</span>
      <div className={tw``}>
        <h3>RTV Type</h3>
        <div className={tw`flex `}>
          <RadioButton
            label="Fixed Amount"
            value="amount"
            checked={selectedRtvType === "amount"}
            onChange={handleRtvTypeChange}
          />
          <RadioButton
            label="Percentage"
            value={"percentage"}
            checked={selectedRtvType === "percentage"}
            onChange={handleRtvTypeChange}
          />
        </div>
      </div>
      <div>
        {selectedRtvType === "amount" ? (
          <NumberField
            value={getValues(`${name}.amount`)}
            setValue={setValue}
            clearErrors={clearErrors}
            placeholder={"RTV Value"}
            register={register(`${name}.amount`)}
            errors={errors?.message?.amount}
            suffix={"Rs."}
          />
        ) : (
          <NumberField
            value={getValues(`${name}.percentage`)}
            setValue={setValue}
            clearErrors={clearErrors}
            placeholder={"RTV Value"}
            register={register(`${name}.percentage`)}
            errors={errors?.message?.percentage}
            suffix={"%"}
          />
        )}
        {errors?.message?.message && (
          <p className={tw`text-red-500 text-xs my-1`}>
            {errors?.message?.message}
          </p>
        )}
      </div>

      <div className={tw``}>
        <h3>Vendor</h3>
        <div className={tw`flex `}>
          <RadioButton
            label="Include"
            value="include"
            checked={selectedVendor === "include"}
            setValue={setValue(
              `${name}.is_include`,
              selectedVendor === "include"
            )}
            onChange={handleVendorChange}
          />
          <RadioButton
            label="Exclude"
            value="exclude"
            checked={selectedVendor === "exclude"}
            setValue={setValue(
              `${name}.is_include`,
              selectedVendor === "include"
            )}
            onChange={handleVendorChange}
          />
        </div>
        <MultipleSelectField
          queryKey={"merchant"}
          register={register(`${name}.vendors` )}
          watch={watch}
          setValue={setValue}
          url={`${APIS.MERCHANT}`}
          clearErrors={clearErrors}
          value={
            data
              ? data?.vendors?.map((item: any, index: number) => ({
                  label: item?.name,
                  value: item?.id,
                }))
              : []
          }
          props={{
            is_active: true,
          }}
          errors={errors?.message}
        />
      </div>
    </div>
  );
};

export default ReturnChargeFrom;
